import api from "../../core/api";
import { Document } from "../models/documentsModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.machineryApiBaseUrl };
}

class PublicDocumentsApi {
  getDocuments(machineNumber: string): Promise<Document[]> {
    return api.get<Document[]>(`/v1/public/machines/${machineNumber}/documents`, getRequestConfig()).then(x => x.data);
  }

  getDocument(documentId: string): Promise<Document> {
    return api.get<Document>(`/v1/public/documents/${documentId}`, getRequestConfig()).then(x => x.data);
  }
}

export default new PublicDocumentsApi();